export default "__VITE_ASSET__CH$gSm2t__"